import {useSelector} from 'react-redux';
import {rootReducer} from 'src/store/reducers';
import {TypeUser} from 'src/defs/types';

export const useUser = (): TypeUser => {
    const {user} = useSelector((state: ReturnType<typeof rootReducer>) => state.account);

    return user;
};
